import $ from 'jquery';
import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import {
  formatBid,
  RECOMMENDATION_TYPES,
} from '@bingads-webui-campaign/recommendation-core';
import { GridCustomizedPopupEditor } from '@bingads-webui-campaign/grid-customized-popup-editor';
import { BidEditorView } from '@bingads-webui-campaign/recommendation-popupeditor';
import edm from '@bingads-webui-component-legacy/edm-campaign/index';

import { isSuggestedBidSupported } from '../const';
import template from './suggested-bid-column.pug';

export class SuggestedBidColumn extends ProjectionGridBaseColumn {
  constructor({
    i18n,
    newI18n,
    recommendationType,
    view,
    deps: { appConfig, jsdata },
    isMCC,
  }) {
    super({
      name: 'SuggestedBid',
      property: 'SuggestedBid',
      title: i18n.getString('Details_View_Suggested_Bid') || '__Suggested bid__',
      bodyClasses: ['grid-column-suggestedBid', 'actionable'],
      colClasses: ['col-number'],
      editable: true,
      type: 'number',
      enableEdit: item => isSuggestedBidSupported(_.first(item.Opportunities)),
    });
    this.i18n = i18n;
    this.newI18n = newI18n;
    this.currency = this.i18n.currency;
    this.view = view;
    this.appConfig = appConfig;
    this.jsdata = jsdata;
    this.edmCampaign = edm;
    this.suggestedBidField = (recommendationType === RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD) ?
      'SuggBid' : 'SuggestedBid';
    this.isMCC = isMCC;
    this.recommendationType = recommendationType;
  }

  get property() {
    return {
      get: _.identity,
      key: 'SuggestedBid',
    };
  }

  template({ value: { Opportunities } }) {
    const {
      i18n, newI18n, currency, suggestedBidField,
    } = this;
    let bidValue;
    let isAutoBidding;
    if (isSuggestedBidSupported(_.first(Opportunities))) {
      bidValue = formatBid(_.chain(Opportunities).first().result('NewBid').value() ||
        _.chain(Opportunities).first().result(suggestedBidField).value(), i18n, currency);
      isAutoBidding = false;
    } else {
      bidValue = newI18n.getString(_TL_('Auto'));
      isAutoBidding = true;
    }
    return template({
      bidValue,
      isAutoBidding,
    });
  }

  onPrompt({
    event,
    item,
    newPosition,
  }) {
    if ($(event.target).is('a')) {
      return undefined;
    }

    const key = $(event.target).parents('tr[data-key]').data('key');

    const {
      i18n,
      suggestedBidField,
      view,
      appConfig,
      jsdata,
      edmCampaign,
      isMCC,
      newI18n,
      recommendationType,
    } = this;

    const bidEditorView = new BidEditorView({
      i18n,
      suggestedBidField,
      item,
      key,
      view,
      appConfig,
      jsdata,
      edmCampaign,
      isMCC,
      newI18n,
      recommendationType,
    });

    const editorView = new GridCustomizedPopupEditor({
      editorView: bidEditorView.render(),
      cellPosition: newPosition,
      renderBelow: false,
      className: 'grid-popupeditor',
      parentContainerSelector: '.grid-and-disclaim-container',
    });

    return editorView.render();
  }
}
